import { WarningCircle } from "@phosphor-icons/react";

interface AnnouncementBannerProps {
  title: string;
  content: React.ReactNode;
  href?: string;
  variant?: "info" | "warning" | "success" | "error";
}

const variantStyles = {
  info: "bg-blue-100",
  warning: "bg-yellow-100",
  success: "bg-green-600",
  error: "bg-red-100",
};

export const AnnouncementBanner = ({ title, content, href, variant = "info" }: AnnouncementBannerProps) => {
  return (
    <div className={`w-full border-b ${variantStyles[variant]}`}>
      <div className="mx-auto flex w-full items-center gap-12 px-20 py-12">
        <WarningCircle
          size={24}
          weight="regular"
          className={href ? "cursor-pointer" : ""}
          onClick={() => {
            if (href) {
              window.open(href, "_blank");
            }
          }}
        />
        <div className="flex flex-col">
          <span className="mb-2 text-13-20 font-medium">{title}</span>
          <div className="text-12-16">{content}</div>
        </div>
      </div>
    </div>
  );
};
